/*LIBRARY*/
import { useRef, useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import Filter from "./Filter";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import {
  set_value_layer,
  pushFeature,
  pushFeatureV2,
} from "../../App/actions/layerActions";

/*PICTURE*/
import ICON_FULL_RAW from "../../Assets/jsx/ICON_FULL_RAW";
import ICON_MINIMIZE_RAW from "../../Assets/jsx/ICON_MINIMIZE_RAW";
import ICON_CLOSE_X_2 from "../../Assets/jsx/ICON_CLOSE_X_2";

/*FUNCTION*/
import uuid from "../../App/validation/uuid";
import { generate_feature_base_value } from "../../App/validation/generateFeature";
import { getAllFields } from "../../App/reduxHelper/layer";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const min_height = window.innerHeight * 0.1;
const max_height = window.innerHeight * 1;
const minimize_height = 319;

const BOTTOM_BAR = ({
  properties,
  set_value_properties,
  set_value_layer,
  content,
  is_open,
  height_var,
  drag_var,
  layer,
  auth,
  pushFeature,
  pushFeatureV2,
}) => {
  const [modalFilter, setModalFilter] = useState(false);
  const [modal_lat_long, set_modal_lat_long] = useState(false);
  const [latitude, set_latitude_state] = useState(-4.409);
  const [longitude, set_longitude_state] = useState(116.966);
  const [keyword_state, set_keyword_state] = useState("");

  // Animation States
  const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);

  const containerRef = useRef(null);
  const rafRef = useRef(null);

  const { layer_id, geo_layer_list } = layer;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id,
  )?.geo_layer;
  const type = geo_layer?.type;
  const features_all = geo_layer?.geojson?.features || [];
  const features_filtered = geo_layer?.geojson_filtered?.features || [];

  const total_length = features_all.length;
  const filtered_length = features_filtered.length;

  //Handle open/close animation states
  useEffect(() => {
    if (is_open) {
      setMounted(true);
      // Wait for the next paint to apply the active class so it transitions from 0
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setActive(true);
        });
      });
    } else {
      setActive(false);
      // Wait for the close transition to finish before unmounting (0.3s matches css transition)
      const timer = setTimeout(() => setMounted(false), 300);
      return () => clearTimeout(timer);
    }
  }, [is_open]);

  const toggleFilter = useCallback(() => {
    setModalFilter((prev) => !prev);
  }, []);

  const toggle_modal_lat_long = useCallback(() => {
    set_modal_lat_long((prev) => !prev);
  }, []);

  const set_latitude = (e) => {
    // Replace comma with point smoothly during text input
    set_latitude_state(e.target.value.replace(",", "."));
  };

  const set_longitude = (e) => {
    // Replace comma with point smoothly during text input
    set_longitude_state(e.target.value.replace(",", "."));
  };

  const handleAddRow = async () => {
    let prop = {};
    let coordinates = {};

    if (type === "Point") {
      prop = {
        icon_image: "museum",
        text_field: "icon_image",
        circle_color: "#dedede",
        circle_radius: 5,
        circle_stroke_width: 1,
        circle_stroke_color: "#fff",
      };

      coordinates = {
        coordinates: [Number(longitude), Number(latitude)],
        type: "Point",
      };
    } else if (type === "Polygon" || type === "MultiPolygon") {
      prop = {
        color: "#dedede",
        opacity: 0.5,
        outline_color: "#fff",
      };

      coordinates = {
        coordinates: [
          [
            [118, -2],
            [117.999911, -2.003407],
            [117.995234, -2.00402],
            [117.99178, -2.0],
            [117.994651, -2.004109],
            [117.996411, -2.009867],
            [117.997071, -2.007579],
            [118.000561, -2.006347],
            [118.001532, -2.008712],
            [118.002694, -2.004759],
            [118.004521, -2.002487],
            [118.003425, -2.000759],
            [118.0009, -2.001043],
            [118, -2],
          ],
        ],
        type: "Polygon",
      };
    } else if (type === "MultiLineString" || type === "LineString") {
      prop = {
        color: "#dedede",
        width: 3,
        line_width: 3,
        opacity: 0.5,
        line_gap_width: 0,
      };
      coordinates = {
        coordinates: [
          [107.95988015062431, -4.088269057402783],
          [126.95661571104824, -5.882793830394718],
        ],
        type: "LineString",
      };
    }

    const fields = getAllFields(geo_layer)?.filter(
      (field) => !field?.parent_uuid,
    );
    prop = { ...prop, ...generate_feature_base_value(fields) };

    const key = uuid();

    let feature = {
      key,
      type: "Feature",
      properties: prop,
      formStatus: {
        status: "digitasi",
        message: "",
        revision_list: [],
      },
      geometry: coordinates,
      isHide: false,
      child_array: [],
      counting_custom_array: [],
      data_pembanding_list: [],
    };

    const body = {
      geo_layer_id: layer.layer_id,
      feature,
    };

    if (geo_layer?.architecture === "v2") {
      await pushFeatureV2(body);
    } else {
      await pushFeature(body);
    }

    if (modal_lat_long) {
      toggle_modal_lat_long();
    }
  };

  const handleAddRowClicked = () => {
    if (type === "Point") {
      const { map_object } = layer;
      if (map_object && typeof map_object.getCenter === "function") {
        const initialCenter = map_object.getCenter();
        const formatCoordinate = (value) => {
          return parseFloat(String(value).replace(",", "."));
        };
        set_longitude_state(formatCoordinate(initialCenter.lng));
        set_latitude_state(formatCoordinate(initialCenter.lat));
      }
      toggle_modal_lat_long();
    } else {
      handleAddRow();
    }
  };

  const height_value = properties[height_var];
  const drag_value = properties[drag_var];
  const {
    is_mobile,
    sidebar_left_status,
    sidebar_right_status,
    bottom_bar_full,
  } = properties;

  const drag_info_ref = useRef({
    initial_y: 0,
    initial_height: 0,
    last_y: 0,
    last_time: 0,
    current_height: 0,
    velocity: 0,
  });

  const on_close_table = useCallback(() => {
    set_value_layer({
      key: "tableStatus",
      value: false,
    });
    set_value_properties({
      key: "sidebar_left_status",
      value: true,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: true,
    });
    set_value_properties({
      key: height_var,
      value: minimize_height,
    });
    set_value_properties({
      key: "bottom_bar_full",
      value: false,
    });
  }, [set_value_layer, set_value_properties, height_var]);

  const set_sidebar_height = useCallback(
    (value) => {
      set_value_properties({ key: height_var, value });
      if (value < min_height) {
        on_close_table();
      }
    },
    [set_value_properties, height_var, on_close_table],
  );

  const set_is_dragging = useCallback(
    (value) => {
      set_value_properties({ key: drag_var, value });
    },
    [set_value_properties, drag_var],
  );

  const handle_mouse_down = (e) => {
    e.preventDefault();
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.clientY,
      initial_height: height_value,
      last_y: e.clientY,
      last_time: Date.now(),
      current_height: height_value,
      velocity: 0,
    };
    window.addEventListener("mousemove", handle_mouse_move);
    window.addEventListener("mouseup", handle_mouse_up);
  };

  const handle_touch_start = (e) => {
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.touches[0].clientY,
      initial_height: height_value,
      last_y: e.touches[0].clientY,
      last_time: Date.now(),
      current_height: height_value,
      velocity: 0,
    };
    window.addEventListener("touchmove", handle_touch_move, { passive: false });
    window.addEventListener("touchend", handle_touch_end);
  };

  const process_move = (current_y) => {
    const deltaY = current_y - drag_info_ref.current.initial_y;
    const new_height = drag_info_ref.current.initial_height - deltaY;

    const now = Date.now();
    const time_diff = now - drag_info_ref.current.last_time;
    const y_diff = current_y - drag_info_ref.current.last_y;
    const velocity = time_diff > 0 ? y_diff / time_diff : 0;

    drag_info_ref.current.last_y = current_y;
    drag_info_ref.current.last_time = now;
    drag_info_ref.current.current_height = new_height;
    drag_info_ref.current.velocity = velocity;

    if (rafRef.current) cancelAnimationFrame(rafRef.current);

    rafRef.current = requestAnimationFrame(() => {
      if (new_height >= min_height && new_height <= max_height) {
        if (containerRef.current) {
          containerRef.current.style.height = `${new_height}px`;
        }
      }
    });
  };

  const handle_mouse_move = (e) => {
    process_move(e.clientY);
  };

  const handle_touch_move = (e) => {
    e.preventDefault();
    process_move(e.touches[0].clientY);
  };

  const on_full = () => {
    const fullHeight = window.innerHeight;
    set_sidebar_height(fullHeight);

    if (containerRef.current) {
      containerRef.current.style.height = `${fullHeight}px`;
    }

    set_value_properties({ key: "bottom_bar_full", value: true });
    set_value_properties({ key: "sidebar_left_status", value: false });
    set_value_properties({ key: "sidebar_right_status", value: false });
  };

  const finalize_drag = () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    const { current_height, velocity } = drag_info_ref.current;

    // Threshold for Snapping to Full Screen (80% window height)
    const threshold_full = window.innerHeight * 0.8;

    if (current_height >= threshold_full) {
      on_full();
    } else if (
      (velocity > 0.3 && current_height < min_height + 60) ||
      current_height < min_height + 10
    ) {
      on_close_table();
    } else if (current_height >= min_height && current_height <= max_height) {
      set_sidebar_height(current_height);
      set_value_properties({
        key: "bottom_bar_full",
        value: false,
      });
    }
  };

  const handle_mouse_up = () => {
    set_is_dragging(false);
    window.removeEventListener("mousemove", handle_mouse_move);
    window.removeEventListener("mouseup", handle_mouse_up);
    finalize_drag();
  };

  const handle_touch_end = () => {
    set_is_dragging(false);
    window.removeEventListener("touchmove", handle_touch_move);
    window.removeEventListener("touchend", handle_touch_end);
    finalize_drag();
  };

  const on_minimize = () => {
    set_sidebar_height(minimize_height);

    if (containerRef.current) {
      containerRef.current.style.height = `${minimize_height}px`;
    }

    set_value_properties({ key: "bottom_bar_full", value: false });
    set_value_properties({ key: "sidebar_left_status", value: true });
    set_value_properties({ key: "sidebar_right_status", value: true });
  };

  let style = {};
  if (is_mobile) {
    style = { bottom: "0", left: "0", width: "100vw" };
  } else {
    if (sidebar_left_status && !sidebar_right_status) {
      style = {
        bottom: "0",
        left: "calc( 289px + 7px )",
        width: "calc(100vw - 289px - 7px)",
      };
    }
    if (!sidebar_left_status && sidebar_right_status) {
      style = { bottom: "0", left: "0", width: "calc(100vw - 289px - 7px)" };
    }
    if (!sidebar_left_status && !sidebar_right_status) {
      style = { bottom: "0", left: "0", width: "100vw" };
    }
    if (sidebar_left_status && sidebar_right_status) {
      style = {
        bottom: "0",
        left: "calc( 289px + 7px )",
        width: "calc(100vw - 289px - 289px - 14px)",
      };
    }
  }

  const modalFilterContent = modalFilter && (
    <Modal
      modalSize="small"
      id="modalFilter"
      isOpen={modalFilter}
      onClose={toggleFilter}
    >
      <div className="box-body" id="box-body">
        <Filter />
        <br />
        <button
          className="button outline_grey button_white"
          onClick={toggleFilter}
        >
          Selesai
        </button>
      </div>
    </Modal>
  );

  const language = localStorage?.language || auth?.language;
  const modal_lat_long_content = type === "Point" && modal_lat_long && (
    <Modal
      title="Longitude and Latitude"
      modalSize="small"
      id="modal_latitude_longitude"
      isOpen={modal_lat_long}
      onClose={toggle_modal_lat_long}
    >
      <section className="margin_bottom">
        <p className="text_medium sub_color margin_bottom">Longitude</p>
        <input
          type="text"
          inputMode="decimal"
          placeholder="Longitude, ex: 125.2342"
          value={longitude}
          onChange={set_longitude}
        />
      </section>

      <br />

      <section className="margin_bottom">
        <p className="text_medium sub_color margin_bottom">Latitude</p>
        <input
          type="text"
          inputMode="decimal"
          placeholder="Latitude, ex: 83.2342"
          value={latitude}
          onChange={set_latitude}
        />
      </section>

      <br />

      <section className="center_perfect margin_top">
        <button
          onClick={handleAddRow}
          className="button_big outline_grey hover_primary"
        >
          {dict?.["Save"]?.[language] || "Save"}
        </button>
      </section>
    </Modal>
  );

  let thumb_width;
  let thumb_height;

  if (is_mobile) {
    thumb_width = drag_value ? "199px" : "75px";
    thumb_height = drag_value ? "29px" : "9px";
  } else {
    thumb_width = drag_value ? "75px" : "55px";
    thumb_height = drag_value ? "11px" : "5px";
  }

  const bottom_bar = (
    <main
      ref={containerRef}
      id="bottom_bar_wrapper"
      style={{
        zIndex: 3,
        position: "fixed",
        height: active ? `${height_value}px` : "0px",
        opacity: active ? 1 : 0,
        overflow: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        transition: drag_value ? "none" : "all 0.3s ease-in-out",
        pointerEvents: "none",
        ...style,
      }}
    >
      {!bottom_bar_full && (
        <div
          id="thumb_resize_hit_area"
          style={{
            width: "100%",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            cursor: "row-resize",
            flexShrink: 0,
            pointerEvents: active ? "auto" : "none",
            backgroundColor: "transparent",
            touchAction: "none",
          }}
          onMouseDown={handle_mouse_down}
          onTouchStart={handle_touch_start}
        >
          <div
            id="action_drag_visual"
            style={{
              width: thumb_width,
              height: thumb_height,
              backgroundColor: "#000",
              borderRadius: "2em",
              transition: "all 0.2s ease-in-out",
              boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
              pointerEvents: "none",
              marginBottom: "6px",
            }}
          />
        </div>
      )}
      <div
        style={{
          flexGrow: 1,
          backgroundColor: "rgba(255, 255, 255, 1)",
          boxShadow: "0 -6px 10px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pointerEvents: active ? "auto" : "none",
          margin: 0,
          padding: 0,
          gap: 0,
          position: "relative",
        }}
      >
        <section
          id="controller"
          style={{
            width: "100%",
            height: "44px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 6px",
            margin: 0,
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        >
          <aside style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <button
              id="action_close"
              className="cursor_pointer background_black"
              style={{
                height: "24px",
                width: "31px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
              }}
              onClick={() => on_close_table()}
            >
              <ICON_CLOSE_X_2 color="#fff" style={{ width: "13px" }} />
            </button>

            <button
              style={{
                display: "flex",
                alignItems: "center",
                height: "24px",
                border: "2px solid #cbd1d8",
                borderRadius: "9px",
                padding: "0 8px",
                gap: "6px",
                backgroundColor: "#fff",
                boxSizing: "border-box",
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ flexShrink: 0 }}
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input
                placeholder="Cari data"
                value={keyword_state}
                onChange={(e) => set_keyword_state(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    set_value_properties({
                      key: "keyword_find",
                      value: keyword_state,
                    });
                  }
                }}
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  height: "100%",
                  width: "100%",
                  padding: 0,
                  margin: 0,
                  fontSize: "13px",
                  color: "#515151",
                  boxSizing: "border-box",
                }}
              />
            </button>
          </aside>

          {/* UPDATED ASIDE WITH DATA COUNT */}
          <aside style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <span
              style={{
                fontSize: "12px",
                color: "#888",
                marginRight: "4px",
                fontWeight: "500",
              }}
            >
              {filtered_length} / {total_length}
            </span>
            <button
              className="button_small button_white outline_grey"
              onClick={toggleFilter}
            >
              Filter
            </button>

            {bottom_bar_full ? (
              <button
                id="action_minimize"
                className="cursor_pointer background_black"
                style={{
                  height: "24px",
                  width: "31px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "none",
                }}
                onClick={() => on_minimize()}
              >
                <ICON_MINIMIZE_RAW color="#fff" style={{ width: "13px" }} />
              </button>
            ) : (
              <button
                id="action_full_screen"
                className="cursor_pointer background_black"
                style={{
                  height: "24px",
                  width: "31px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "none",
                }}
                onClick={() => on_full()}
              >
                <ICON_FULL_RAW color="#fff" style={{ width: "13px" }} />
              </button>
            )}
          </aside>
        </section>

        <section
          id="table"
          style={{
            flexGrow: 1,
            overflowY: "hidden",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            margin: 0,
            padding: 0,
          }}
        >
          {content}
        </section>

        {type === "Point" && (
          <button
            className="button_big background_grey_light outline_white"
            style={{
              position: "absolute",
              bottom: "15px",
              right: "15px",
              zIndex: 10,
              width: "51px",
              fontSize: "21px",
            }}
            onClick={handleAddRowClicked}
          >
            +
          </button>
        )}
      </div>
    </main>
  );

  let final_content = mounted ? bottom_bar : null;

  return (
    <main>
      {final_content}
      {modalFilterContent}
      {modal_lat_long_content}
    </main>
  );
};

const map_state_to_props = (state) => ({
  layer: state.layer,
  properties: state.properties,
  auth: state.auth,
});

export default connect(map_state_to_props, {
  set_value_properties,
  set_value_layer,
  pushFeature,
  pushFeatureV2,
})(BOTTOM_BAR);
